import { RenderLoop } from "./RenderLoop";
import { CameraController } from './CameraController';
import { RoomBakedScene } from "./RoomBakedScene";

import { store } from '../Store';


export class SceneViewer {
  constructor(options) {
    this.renderLoop = new RenderLoop({
      canvas: options.canvas,
      autoClear: true,
      alpha: false,
      antialias: options.antialias || true,
      maxPixelRatio: Math.min(window.devicePixelRatio, options.maxPixelRatio || 1.5),
      clearColor: 0xffffff,
      width: window.innerWidth,
      height: window.innerHeight,
      onUpdate: this.onUpdate.bind(this),
      onRender: this.onRender.bind(this),
      onResize: this.onResize.bind(this)
    });

    this.scene = null;

    this.cameraController = new CameraController(this.renderLoop.domElement);
    this.camera = this.cameraController.camera;
    this.renderLoop.registerCamera(this.camera);
  }

  async load() {
    this.scene = new RoomBakedScene();
    
    await this.scene.load(this.renderLoop.renderer);

    this.scene.onLoad(this);

    store.setSceneLoaded();
    store.setLoadingPercentage(100);
  }

  start() {
    this.renderLoop.start();

    store.setStarted();

    this.cameraController.playIntroAnimation();
  }

  dispose() {

  }

  onResize(width, height) {
    this.scene.onResize(width, height, this.cameraController);

    store.setNeedsRender(true);
  }

  onUpdate() {
    this.cameraController.update();
    this.scene.update(this.cameraController);
  }

  onRender() {
    if (this.scene && this.camera && store.needsRender) {
      this.renderLoop.renderScene(this.scene, this.camera);

      store.setNeedsRender(false);
    }
  }
}